module.exports = __webpack_public_path__ + "static/socialimpact-45f288f2c31435f4f904f9c55711a9d4.jpeg";